<template>
  <div>
    <div
      class="nav-item user-menu dropdown d-none d-md-block"
      :class="{ show: opened }"
      @click="opened = !opened"
    >
      <div class="btn btn-user" type="button" :class="{ expand: opened }">
        <gravatar
          alt="avatar"
          :size="60"
          default-img="identicon"
          :email="$store.state.user.email"
        />
        <p class="btn-username">{{ username | shortText(16) }}</p>
      </div>
      <div
        class="dropdown-menu"
        :class="{ show: opened }"
        aria-labelledby="dropdownMenuButton"
      >
        <theme-selector />
        <logout />
      </div>
    </div>
    <div class="user-menu user-menu-mob d-md-none">
      <div class="btn btn-user">
        <gravatar
          alt="avatar"
          :size="60"
          default-img="identicon"
          :email="$store.state.user.email"
        />
        <p class="btn-username">{{ username | shortText(24) }}</p>
      </div>
      <theme-selector />
      <logout />
    </div>
  </div>
</template>

<script>
import Gravatar from 'vue-gravatar'
import ThemeSelector from './ThemeSelector'
import Logout from './Logout'
import filters from '@/utils/filters'

export default {
  components: {
    gravatar: Gravatar,
    'theme-selector': ThemeSelector,
    logout: Logout,
  },
  data() {
    return {
      opened: false,
    }
  },
  computed: {
    email: () => this.$store.state.user.email,
    username() {
      return this.$store.state.user.email.split('@')[0]
    },
  },
  filters: {
    shortText: filters.shortText,
  },
}
</script>

<style lang="scss">
.navbar {
  .user-bars {
    display: flex;
    justify-content: flex-end;
    @media (max-width: 1199px) {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    @media (max-width: 768px) {
      width: 100%;
      justify-content: space-between;
    }
    @media (max-width: 576px) {
      padding-left: 42px;
    }

    .nav-item {
      .notification {
        width: 70px;
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        @include transition();

        &:hover span {
          color: $primary-color2;
        }

        .fa {
          color: #f9a400;
        }
        span {
          color: #d1d1de;
          vertical-align: middle;
        }
      }
    }
  }

  .nav-btn {
    margin-left: 20px;

    @media (max-width: 1199px) {
      margin-left: 0;
      margin-bottom: 40px;
    }

    .primary-btn {
      @media (max-width: 1199px) {
      }
    }
  }
}

.user-menu {
  .btn-user {
    background: transparent;
    border: none;
    padding: 0 15px;
    color: #fff;
    vertical-align: middle;

    &:hover {
      color: $primary-color2;
    }

    &:after {
      position: absolute;
      content: '\f107';
      height: 10px;
      line-height: 0.625rem;
      width: 10px;
      font-family: FontAwesome;
      top: 12px;
      right: 0px;
      @media (max-width: 768px) {
        display: none;
      }
    }

    img {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 10px;
      @media (max-width: 768px) {
        width: 32px;
        height: 32px;
      }
    }
  }
  .btn-username {
    display: inline-block;
    margin: 0;
    padding-left: 4px;
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
  .dropdown-menu {
    background-color: #000000;
    color: #fff;
    z-index: 2;
    padding: 0;
    border-radius: 4px;
    right: 0;
    top: calc(100% + 20px);

    .dropdown-item {
      color: #fff;
      background-color: #000;
      height: 45px;
      padding: 7px 1.5rem;
      min-width: 15rem;

      &:hover &:last-child {
        padding-bottom: 0.5rem;
      }

      &:hover {
        color: #00a6cb;
        background-color: #000;
        cursor: pointer;

        svg path {
          stroke: #00a6cb !important;
        }
      }
    }
    &.show:before {
      width: 100%;
      height: 100%;
      position: fixed;
      background: #fff;
      content: '';
      left: 0;
      top: 0;
      opacity: 0.6;
      z-index: -1;
    }
  }

  &-mob {
    @media (min-width: 568px) {
      padding-left: 6px;
    }
    div:first-child {
      margin-left: -42px;
    }
    & > * {
      margin-bottom: 14px;
    }
  }

  .dropdown-item {
    @media (max-width: 768px) {
      &:hover {
        background-color: inherit;
        color: $primary-color2;
      }
    }
  }
}

.btn {
  &-settings {
    background-color: transparent;
    border: 0;
    position: relative;

    &:before {
      content: '';
      width: 100%;
      height: 100%;
      background-color: rgba(#fff, 0.7);
      position: fixed;
      right: 0;
      top: 0;
      z-index: -1;
      color: currentColor;
      cursor: not-allowed;
      text-decoration: none;
      pointer-events: none !important;
    }

    svg {
      &:first-child {
        display: block;
      }
      &:last-child {
        display: none;
      }
    }
    &.expand {
      z-index: 1;

      svg {
        &:first-child {
          display: none !important;
        }
        &:last-child {
          display: block !important;
        }
      }
    }
  }
  &-search {
    border: 0;
    width: 50px;
    position: relative;
    text-align: center;
    background-color: transparent;

    &:after {
      width: 1px;
      height: 20px;
      content: '';
      background-color: #c2c2d6;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }

    &:hover svg path {
      stroke: $primary-color2;
    }
  }

  &-text {
    background-color: transparent;
    float: right;
    margin-top: -6px;
    font-size: 1.125rem;
    padding: 0;
  }
}
</style>
